import React from 'react';
import PropTypes from 'prop-types';

const InlineButton = props => {
  const { children, onClick, link } = props;

  return (
    <span
      className="auth__container__content__link"
      onClick={() => onClick && onClick()}
      onKeyDown={e => e.keyCode === 13 && onClick()}
      role="button"
      tabIndex="0"
    >
      {
        link ? <a style={{color: 'inherit', textDecoration: 'none' }} href={link} target='_blank'>{children}</a> : children
      }
    </span>
  );
};

InlineButton.defaultProps = {
  onClick: null,
};

InlineButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default InlineButton;
